module.exports = __webpack_public_path__ + "media/images/category/feature/coj_d/coj_d-1-eece2cd24cf0f82c2a3cec80206dc5e7.jpg";